import * as React from 'react';

import { CiriumWrapper } from '../../components/cirium/CiriumWrapper';
import { TravelerRegisterPage } from './TravelerRegisterPage';
import { sanitizeBrandingImageUrl } from '../brandingImageUtils';
import { useLocation, useParams, useSearchParams } from 'react-router-dom';
import QueryString from 'qs';

const TravelerRegisterPreviewContainer: React.FC = () => {
    const { search } = useLocation()
    const values = QueryString.parse(search) as Record<string, any>;
  return (
    <CiriumWrapper>
      <TravelerRegisterPage
        brandingImageUrl={sanitizeBrandingImageUrl(values['?brandingImageUrl'] || '')}
        disabled={true}
        usernameValidation={() => true}
        passwordValidation={() => true}
        handleTravelerRegister={() => {}}
        email={'joeTraveler@example.com'}
        isExistingUsername={false}
        displayExistingUsernameMsg={false}
        closeExistingUsernameMsg={() => {}}
      />
    </CiriumWrapper>
  );
};

export default TravelerRegisterPreviewContainer;
